import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Pic from "@/components/common/Pic";

const WhereToStaySection = () => {
  const { t, i18n } = useTranslation();
  // Extract base language code (e.g., 'en' from 'en-US' or 'en-US@posix')
  const lang = i18n.language?.split('-')[0]?.split('@')[0] || 'en';
  
  const houses = [
    {
      name: t('ui.whereToStay.manor.name'),
      guests: t('ui.whereToStay.manor.guests'),
      image: "/images/homepage/manor.webp",
      link: `/${lang}/houses/manor`
    },
    {
      name: t('ui.whereToStay.woodOvenI.name'),
      guests: t('ui.whereToStay.woodOvenI.guests'),
      image: "/images/houses/woodoven1_outside.webp",
      link: `/${lang}/houses/wood-oven-i`
    },
    {
      name: t('ui.whereToStay.woodOvenII.name'),
      guests: t('ui.whereToStay.woodOvenII.guests'),
      image: "/images/homepage/wheretostay_ext.webp",
      link: `/${lang}/houses/wood-oven-ii`
    },
    {
      name: t('ui.whereToStay.pinetree.name'),
      guests: t('ui.whereToStay.pinetree.guests'),
      image: "/images/houses/pinetree_outside_1.webp",
      link: `/${lang}/houses/pinetree`
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-stone-100" data-testid="where-to-stay-section">
      <div className="max-w-5xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-10">
          <span className="pretitle">{t('ui.whereToStay.pretitle')}</span>
          <h2 className="font-sans text-2xl md:text-3xl text-[#33685F] font-semibold">
            {t('ui.whereToStay.title')}
          </h2>
        </div>
        
        {/* Houses Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-10">
          {houses.map((house, index) => (
            <Link 
              key={index} 
              to={house.link}
              className="group block"
            >
              <div className="overflow-hidden mb-3">
                <Pic
                  src={house.image}
                  alt={house.name}
                  className="w-full h-44 md:h-48 object-cover grayscale-[20%] group-hover:grayscale-0 transition-all duration-300"
                  loading="lazy"
                />
              </div>
              <p className="font-sans text-[#33685F] font-bold text-sm md:text-base">
                {house.name}
              </p>
              <p className="font-sans text-[#3F7A6E] text-sm italic">
                {house.guests}
              </p>
            </Link>
          ))}
        </div>
        
        {/* CTA */}
        <div className="text-center">
          <p className="font-sans text-[#33685F] text-sm mb-1">
            {t('ui.whereToStay.ctaLine1')}
          </p>
          <p className="font-sans text-[#3F7A6E] text-sm mb-5">
            {t('ui.whereToStay.ctaLine2')}
          </p>
          <Link 
            to="/book"
            className="inline-block px-8 py-3 border-2 border-[#33685F] text-[#33685F] font-sans uppercase tracking-wider text-xs transition-all duration-300 hover:bg-[#33685F] hover:text-white"
          >
            {t('ui.whereToStay.bookButton')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhereToStaySection;
